import { formatPrice, updateRelatedContainers, updateRelatedSection } from './relatedProductsHelper.js';

function updateRelatedSections(items, container) {
  updateRelatedSection(items, container, getProductCard);
}

function getProductCard(product, index, sectionKey = 'related') {
  const uniqueKey = `${sectionKey}-${product.id}-${index}`;

  return `
    <div
      id="Slide--${uniqueKey}"
      class="complementary-slide complementary-slide--card"
      role="listitem"
    >
      <ul class="list-unstyled" role="list">
        <li>
          <product-card class="block card-wrapper product-card-wrapper">
            <div
              class="product-card card card--card card--shape-landscape_wide card--text-left card--media color-scheme-2 gradient card--shadow"
              style="--ratio-percent: 56.49717514124294%"
              data-product-handle="${product.handle}"
              data-product-vendor="${product.vendor}"
            >
              <div class="card__inner ratio" style="--ratio-percent: 56.49717514124294%">
                <div class="card__media">
                  <div class="media media--transparent media--hover-effect">
                    <img
                      class="card__image motion-reduce object-center object-contain"
                      src="${product.image}"
                      alt="${product.title}"
                    />
                  </div>
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading text-body t3 font-bold" id="title--${uniqueKey}">
                    <a href="${product.url}" id="CardLink--${uniqueKey}" class="full-unstyled-link uppercase">
                      ${product.title}
                    </a>
                  </h3>
                  <div class="card-information">
                    <div class="price t2 uppercase">
                      <div class="price__container">
                        <div class="price__regular">
                          <span class="price-item price-item--regular">${formatPrice(product.price)}</span>
                        </div>
                      </div>
                    </div>
                    <div data-cm-related-fitment aria-live="polite"></div>
                  </div>
                </div>
              </div>
            </div>
          </product-card>
        </li>
      </ul>
    </div>
  `;
}

export const updatePDPRelatedProducts = (vehicle) => {
  const relatedRequiredProducts =
    document.getElementById('cm-related-required') ||
    document.querySelector('.cm_related-required.is-product-page');
  const relatedAccessoriesProducts = document.querySelector(
    'body.product-template .section-related-accessories .cm_related-accessories',
  );
  const description = document.querySelector('#MainContent > .section-rich-text');
  let customizationOptions = document.querySelector('.cm_customization-options');
  if (description) {
    if (relatedRequiredProducts) {
      const originalRequiredProducts = document.querySelector('product-info .cm_related-required');
      if (originalRequiredProducts && originalRequiredProducts !== relatedRequiredProducts) {
        originalRequiredProducts.remove();
      }
      relatedRequiredProducts.id = 'cm-related-required';
      relatedRequiredProducts.classList.add('cm_related-section');
      relatedRequiredProducts
        .querySelector('.complementary-products__container')
        ?.classList.add('page-width');
      relatedRequiredProducts.querySelector('.complementary-products__container')?.classList.remove('mt-1');
      relatedRequiredProducts.querySelector('h2').textContent =
        window.Convermax.translations.related_items_required_title;
      let subtitle = relatedRequiredProducts.querySelector('.cm_related-section_description');
      if (!subtitle) {
        subtitle = document.createElement('p');
        subtitle.className = 'cm_related-section_description';
        relatedRequiredProducts.querySelector('.summary__title').after(subtitle);
      }
      subtitle.textContent = window.Convermax.translations.related_items_required_description;
      description.after(relatedRequiredProducts);
    }
    if (!customizationOptions) {
      customizationOptions = document.createElement('section');
      customizationOptions.id = 'cm-related-customization';
      customizationOptions.className = 'cm_customization-options cm_related-section is-product-page';
      customizationOptions.style.display = 'none';
      customizationOptions.innerHTML = `
        <div class="page-width">
          <div class="summary__title">
            <h2>${window.Convermax.translations.related_items_customization_title}</h2>
          </div>
          <p class="cm_related-section_description">
            ${window.Convermax.translations.related_items_customization_description}
          </p>
          <div class="cm_related-section_carousel"></div>
        </div>
      `;
      description.before(customizationOptions);
    }
  }
  if (relatedAccessoriesProducts) {
    relatedAccessoriesProducts.id = 'cm-related-accessories';
    relatedAccessoriesProducts.classList.add('cm_related-section');
    relatedAccessoriesProducts.querySelector('.related-products__title')?.classList.remove('title-wrapper');
    relatedAccessoriesProducts.querySelector('slideshow-component')?.classList.remove('page-width-desktop');
    const relatedDescription = relatedAccessoriesProducts.querySelector('.related-accessories__description');
    relatedDescription?.classList.add('cm_related-section_description');
    relatedDescription?.removeAttribute('style');
  }
  const productId = window.Convermax?.Shopify?.productId;
  const variantId = window.Convermax?.Shopify?.getVariantId();

  updateRelatedContainers({
    relatedRequiredProducts,
    relatedAccessoriesProducts,
    customizationOptions,
    productIds: variantId || productId,
    vehicle,
    updateSection: updateRelatedSections,
  });
};

export const addPDPEventListeners = () => {
  updatePDPRelatedProducts();

  const variantSelects = window.document.querySelectorAll('body.product-template variant-selects');
  variantSelects?.forEach((select) => {
    select.addEventListener('change', () => {
      updatePDPRelatedProducts();
    });
  });
};
